<template>
  <section class="footer">
    <div class="container">
      <h2>Gigtrick</h2><span class='small-text'>Eine Marke von LandoltPeinsippSemler GesbR.</span>
      <p>Kontakt: dominik@gigtrick.at<br>www.gigtrick.at</p>
      <div class="footer-links">
        <a href="#features">Features</a>
        <a href="#pricing">Pricing</a>
        <a href="#contact">Contact Us</a>
        <a href="/datenschutz" class="extra-link">Datenschutz</a> <!-- 👈 New Link -->
      </div>
      <div class="social-icons">
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
h2{
  color: #fff;
  margin: 0;
  padding: 0;
}

.footer {
  background-color: #000; /* Solid black background */
  color: #fff;
  display: flex;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  width: 100%;
  margin-top: 5rem; /* Large margin at the top */
}

.small-text {
  font-size: 0.8rem;

}

@media (max-width: 768px) {
  .footer {
    padding: 1rem;
    text-align: center;
  }
  .footer-links {
    flex-direction: column;
    gap: 1rem;
  }
  .social-icons {
    flex-direction: row;
    gap: 0.5rem;
  }
}

.footer-links {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  gap: 1.5rem;
}

.footer-links a {
  color: #ff5a5f;
  text-decoration: none;
}
.footer-links a:hover {
  text-decoration: underline;
}

.social-icons a img:hover {
  transform: scale(1.1);
  transition: transform 0.3s;
}

.social-icons {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
}

.social-icons img {
  width: 24px;
  height: 24px;
}

.container {
  background: rgba(0, 0, 0, 1); /* Fully black background */
  padding: 4rem;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (max-width: 768px) {
  .container {
    padding-top: 10rem;
  }
}
</style>
